import Link from 'next/link';
import { ReactNode } from 'react';
import { useFormStatus } from 'react-dom';
import { twMerge } from 'tailwind-merge';
import { UrlObject } from 'url';

interface Props {
    href?: string | UrlObject;
    onClick?: () => void;
    form?: string;
    tooltip?: string;
    disabled?: boolean;
    className?: string;
    children: ReactNode;
    target?: string;
    type?: 'button' | 'submit' | 'reset';
    ariaLabel?: string;
}

export function GhostButton({
    onClick,
    href,
    form,
    tooltip,
    disabled = false,
    className,
    children,
    target,
    type = 'button',
    ariaLabel,
}: Props) {
    const { pending } = useFormStatus();

    const classNames = twMerge(
        'inline-block',
        'bg-transparent',
        'p-0',
        'm-0',
        'cursor-pointer',
        'text-inherit',
        'font-inherit',
        'disabled:pointer-events-none',
        'data-[disabled]:pointer-events-none',
        className,
    );

    if (href != null) {
        return (
            <Link
                className={classNames}
                href={href}
                target={target}
                title={tooltip}
                aria-label={ariaLabel}
                data-disabled={disabled || undefined}
                onClick={onClick}>
                {children}
            </Link>
        );
    }

    return (
        <button
            className={classNames}
            type={onClick == null && form != null ? 'submit' : type}
            onClick={onClick}
            disabled={disabled || pending}
            form={form}
            title={tooltip}
            aria-label={ariaLabel}>
            {children}
        </button>
    );
}
